module.exports = __webpack_public_path__ + "img/soyamilk.4e86f626.jpg";